import { useLocation, useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocalStorage } from '../../services/hooks/useLocalStorage';
import { lookupTenantFromIssuer, getTenants, getUserDataFromToken } from '../../services/api';
import { STC_ID, STRATUS_ID } from '../../services/constants';
import jwtDecode from 'jwt-decode';

import Header from '../Header';
import Loading from '../Loading';

const FromDipa = () => {
    const location = useLocation();
    const history = useHistory();
    const [_sqta, setSqta] = useLocalStorage('dipa-sqta', '');
    const [_noDipa, setNoDipa] = useLocalStorage('noDipa', false);
    const [_stratus, setStratus] = useLocalStorage("stratus", false);
    const [_appVersion, setAppVersion] = useLocalStorage('appVersion', '')

    useEffect(() => {
        async function checkDeviceLicense(tenant, stratus) {
            let appId = STC_ID;
            if (stratus) {
                appId = STRATUS_ID;
            }
            const tenantsList = await getTenants(appId);
            return tenantsList.some(t => t.id === tenant.id)
        }
        async function handleToken() {
            const params = new URLSearchParams(location.search);
            const version = location.state?.version || params.get("version");
            if (version) {
                setAppVersion(version)
            }
            const isStratusPresent = params.get("stratus");
            if (isStratusPresent) {
                setStratus(true);
            } else {
                // If both STC and Stratus are installed, this will help switch between both of them
                setStratus(false);
            }
            const tokenSQTA = location.state?.sqta || params.get("sqta");
            const tokenCognito = location.state?.cognito || params.get("cognito");
            if (tokenSQTA && tokenSQTA.length > 0) {
                setSqta(tokenSQTA);
                setNoDipa(false);
            }
            if (tokenCognito && tokenCognito.length > 0) {
                try {
                    const decodedCognito = jwtDecode(tokenCognito);
                    const iss = decodedCognito.iss;
                    const issuer = iss.slice(iss.lastIndexOf('/')+1)
                    const tenant = await lookupTenantFromIssuer(issuer);
                    const isLicensed = await checkDeviceLicense(tenant, isStratusPresent);
                    if (!isLicensed) {
                        history.push('/unlicensed')
                        return
                    }
                    const userData = await getUserDataFromToken(tokenCognito, tenant.slug, tenant.region);
                    history.push('/', { user: userData.user.email, tenant, accessToken: tokenCognito, client: { ClientId: decodedCognito.client_id } })
                    return;
                } catch (e) {
                    console.error(e);
                    history.push('/');
                }
            }
        }
        handleToken();
    // eslint-disable-next-line
    }, [history, location.search, location.state?.cognito, location.state?.sqta, setSqta, setNoDipa])

    return (
        <>
            <Header />
            <Loading />
        </>
    )
}

export default FromDipa